export const convertToTimestamp = (dateString?: string): string | undefined => {
  return dateString ? new Date(dateString).getTime().toString() : undefined;
};
